import { render, staticRenderFns } from "./ClimateCarousel.vue?vue&type=template&id=582aeb59&scoped=true"
import script from "./ClimateCarousel.vue?vue&type=script&lang=js"
export * from "./ClimateCarousel.vue?vue&type=script&lang=js"
import style0 from "./ClimateCarousel.vue?vue&type=style&index=0&id=582aeb59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582aeb59",
  null
  
)

export default component.exports